// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import { VueMaskDirective } from 'v-mask'
import Vue2Filters from 'vue2-filters'

import money from 'v-money'
import VueNumeric from 'vue-numeric'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-default/index.css'

import App from './App'
import router from './router'

import auth from './auth'
import { HTTP } from './http-common'

Vue.config.productionTip = false

Vue.directive('mask', VueMaskDirective)
Vue.use(Vue2Filters)
Vue.use(money, { precision: 2, prefix: '' })
Vue.use(VueNumeric)
Vue.use(ElementUI, { locale })

/* eslint-disable no-new */
var app = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

HTTP.interceptors.request.use(function (config) {
  // Do something before request is sent
  app.$children[0].showAnimation()
  return config
}, function (error) {
  app.$children[0].hideAnimation()
  // Do something with request error
  return Promise.reject(error)
})

HTTP.interceptors.response.use((response) => {
  app.$children[0].hideAnimation()
  return response
}, function (error) {
  // Do something with response error
  if (error.response.status === 401) {
    app.$children[0].hideAnimation()
    console.log('unauthorized, logging out ...')
    auth.logout()
    router.replace('/login')
  }
  app.$children[0].hideAnimation()
  return Promise.reject(error)
})



// WEBPACK FOOTER //
// ./src/main.js